import { render, staticRenderFns } from "./PageCloudImportFilePreview.vue?vue&type=template&id=6cb047c6&scoped=true&"
import script from "./PageCloudImportFilePreview.vue?vue&type=script&lang=js&"
export * from "./PageCloudImportFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./PageCloudImportFilePreview.vue?vue&type=style&index=0&id=6cb047c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb047c6",
  null
  
)

export default component.exports